import { effectiveLocationStr } from '../../../helpers/utils'
import { getSelectValues, buildSelectValue } from '../../../components/Filters/filterSelectState'
import { getTimestampFromDateTime } from '../../../helpers/formatDate'
import { formatMoney } from '../../../helpers/utils'

export const ACTIVITY_FILTER_KEYS = {
  client: 'CLIENTE',
  activity: 'ACTIVIDADES',
  geofence: 'DENTRO DE GEOCERCA'
}

export const createEmptyActivityFilterSelections = () => ({
  [ACTIVITY_FILTER_KEYS.client]: buildSelectValue(),
  [ACTIVITY_FILTER_KEYS.activity]: buildSelectValue(),
  [ACTIVITY_FILTER_KEYS.geofence]: buildSelectValue()
})

const ACTIVITY_FILTER_MAPPINGS = {
  [ACTIVITY_FILTER_KEYS.client]: 'client_uid',
  [ACTIVITY_FILTER_KEYS.activity]: 'activity_name',
  [ACTIVITY_FILTER_KEYS.geofence]: 'in_geofence'
}

export function buildActivityFilterQuery(selections = new Map()) {
  let queryParam = ''
  const entries = selections instanceof Map ? selections.entries() : Object.entries(selections)

  for (const [key, value] of entries) {
    const values = Array.isArray(value) ? value : getSelectValues(value)
    if (!values.length) continue
    const paramKey = ACTIVITY_FILTER_MAPPINGS[key]
    if (paramKey) {
      queryParam += `&${paramKey}=${values.join(',')}`
    }
  }

  return queryParam
}

export function resolveActivityGeofenceLabel(row) {
  if (row?.activity_name?.includes('LIQUID')) return '-'
  return effectiveLocationStr(row.effective_location, row.client_latitude, row.latitude)
}

export function buildActivityTableRows(rows = [], formatActivityName) {
  return (rows || []).map((row, index) => ({
    rowKey: row.activity_uid || `${row.client_uid}-${row.created_date}-${index}`,
    rawRow: row,
    createdDateLabel: getTimestampFromDateTime(row.created_date),
    clientUid: row.client_uid || '-',
    clientName: row.client_name || '-',
    clientLabel: [row.client_uid, row.client_name].filter(Boolean).join(' - ') || '-',
    activityLabel: formatActivityName(row.activity_name),
    activityName: row.activity_name,
    motiveText: row.motive_text || '-',
    totalLabel: row.total != null ? formatMoney(row.total) : '-',
    geofenceLabel: resolveActivityGeofenceLabel(row),
    isLiquidation: row.activity_name?.includes('LIQUID'),
    isErrorActivity:
      row.activity_name?.includes('ANULAD') || row.activity_name?.includes('RECHAZAD')
  }))
}

const normalize = (value) =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

export function filterActivityRows(rows, selections, query, range) {
  const clients = getSelectValues(selections.client)
  const activities = getSelectValues(selections.activity)
  const geofence = getSelectValues(selections.geofence)
  const search = normalize(query.trim())
  return rows.filter((row) => {
    const location = resolveActivityGeofenceLabel(row)
    const date = new Date(row.created_date).getTime()
    return (
      (!clients.length || clients.includes(row.client_uid)) &&
      (!activities.length || activities.includes(row.activity_name)) &&
      (!geofence.length || geofence.includes(location)) &&
      (!search || normalize(`${row.client_uid} ${row.client_name}`).includes(search)) &&
      (!range.start || date >= new Date(range.start).getTime()) &&
      (!range.end || date <= new Date(`${range.end}:59.999`).getTime())
    )
  })
}
